import React, { useState, useEffect } from 'react'
import { ReactSearchAutocomplete } from 'react-search-autocomplete'

const Search = (props) => {
  const [ searchData, setSearchData] = useState([])
  const [ marker, setMarker ] = useState()
  const [ highlightMarker, setHighlightMarker ] = useState()
  const [ enterSearch, setEnterSearch] = useState(false)

  useEffect(() => {
    setMarker(() => new RichMarker({
      map: null,
      draggable: false,
      flat: true,
      clickable: false,
      visible: true,
      zIndex: 600,
      shadow: 'none',
      position: new google.maps.LatLng(Number(props.mapSettings.lat), Number(props.mapSettings.lon)),
      title: 'Search Marker',
      content: `<div class="sopa-map--search_marker standard"><span></span></div>`
    }))
    setHighlightMarker(() => new RichMarker({
      map: null,
      draggable: false,
      flat: true,
      clickable: false,
      visible: true,
      zIndex: 600,
      shadow: 'none',
      position: new google.maps.LatLng(Number(props.mapSettings.lat), Number(props.mapSettings.lon)),
      title: 'Search Marker',
      content: `<div class="sopa-map--search_marker highlight"><span></span></div>`
    }))
  }, [props.activePins, props.richMarkerReady])

  useEffect(() => {
    if (props.data === undefined) return;
    setSearchData(() => {
      // the search plugin requires that the top level of each item has an 'id' property
      // this allows it to avoid key issues with multiple components of the same type in the search results.
      // todo: it would be nice to fork this and allow the ID key to be specified.
      const newState = []

      props.data.forEach(datum => {
        datum.name = datum.title
        const iconIdx = props.categories.findIndex(cat => cat.id === datum.category.id)
        if (iconIdx) {
          datum.icon = props.categories[iconIdx].icon
        }
        newState.push(datum)

      })
      return [...newState]
    })
  }, [props.data])

  const handleOnSearch = (string, results) => {
    // onSearch will have as the first callback parameter
    // the string searched and for the second the results.
    setEnterSearch(() => {
      // every time the search results list is updated we store the first one so the user can hit the enter key and get a result.
      return (results[0] || undefined)
    })
    return
  }

  const handleOnHover = (result) => {
    // the item hovered

    // reset both search markers
    marker.setMap(null)
    highlightMarker.setMap(null)

    const currentMarker = (result.category.name.toLowerCase() === 'venue') ? highlightMarker : marker
    currentMarker.setMap(props.map)
    currentMarker.setPosition({
      lat: result.geofield.lat,
      lng: result.geofield.lon
    })
  }

  const handleOnClear = (item) => {
    // remove the marker if clear is used.
    marker.setMap(null)
    highlightMarker.setMap(null)
  }

  const handleOnSubmit = (evt:Event) => {
    evt.preventDefault()
    handleOnSelect(enterSearch)
  }

  const handleOnSelect = item => {
    const latLng = new google.maps.LatLng(Number(item.geofield.lat), Number(item.geofield.lon))
    props.setActivePins(prevState => {
      const newState = [...prevState]
      const chosenPinIdx = newState.findIndex(ap => ap.id === item.id)
      newState.forEach(item => {
        item.wasSearched = false
      })

      if (chosenPinIdx > -1) {
        newState[chosenPinIdx].visible = true
        newState[chosenPinIdx].wasSearched = true
      }
      return props.testForAccessibility(newState)
    })
    // centre the map on the chosen point
    props.map.setCenter(latLng)
    props.map.panTo(latLng)
    props.setFiltersActive(false)
    // remove the search marker from the map
    marker.setMap(null)
    highlightMarker.setMap(null)
  }

  const formatResult = (item) => {
    return (
      <>
        <div className="sopa-map--search_result-item">
          {item.icon && <span className="sopa-map--search_result-item_image"><img src={item.icon} /></span>}
          <span className="sopa-map--search_result-item_title">{item.title}</span>
        </div>
      </>
    )
  }

  return (
    <>
      <form
        onSubmit={handleOnSubmit}
      >
        <ReactSearchAutocomplete
          items={searchData}
          showIcon={true}
          placeholder="Search term goes here"
          showNoResultsText="No locations found"
          fuseOptions={{
            findAllMatches: true,
            minMatchCharLength: 2,
            keys: ['title', 'shortDescription', 'description', 'category.name', 'venue.name']
          }}
          onSearch={handleOnSearch}
          onHover={handleOnHover}
          onClear={handleOnClear}
          onSelect={handleOnSelect}
          formatResult={formatResult}
          className='sopa-map--search_widget'
          />
      </form>
    </>
  )
}

export default Search
